export const PENDING_COURSES = [
  'hr',
  'market',
  'customer',
  'it',
  'E-commerce',
  'ngo',
  'startup',
  'ransomware',
  'socialMedia',
  'ppd',
  'dataLeakage',
  'whatsapp',
  'aiSecurity',
];
